import * as React from "react";
import { Tab, Grid, Button, Menu } from "semantic-ui-react";

import { useDispatch, useSelector } from "@teamprevent/customer-redux";

import { ApplicationState } from "../../../../applicationState";
import { ohCaseSelector } from "../../selectors";
import { loadOhCaseDocuments } from "../../actions";

import { DocumentsTabLabel } from "./DocumentsTabLabel";

export const Documents: React.FunctionComponent= () => {
    const ohCaseId = useSelector((state: ApplicationState) => state.router.params!.ohCaseId);
    const ohCase = useSelector((state: ApplicationState) => ohCaseSelector(state));

    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(loadOhCaseDocuments({ ohCaseId }));
    }, [dispatch, ohCaseId]);

    return (
        <Grid>
            {ohCase.documents && ohCase.documents.map((document) => {
                const downloadUrl = `/api/case/${ohCaseId}/document/${document.id}?fileName=${document.name}`;
                return (
                    <Grid.Row columns="equal" key={document.id} className="case-documents-list">
                        <Grid.Column>
                            <a href={downloadUrl} className="document-title">{document.name}</a>
                            <p>{document.documentType}</p>
                        </Grid.Column>
                        <Grid.Column textAlign="right">
                            <a href={downloadUrl}><Button secondary>Download</Button></a>
                        </Grid.Column>
                    </Grid.Row>
                );
            })}
        </Grid>
    );
};

export const documentsTab = () => ({
    path: "/documents",
    menuItem: (
        <Menu.Item key='documents'>
            Documents <DocumentsTabLabel />
        </Menu.Item>
    ),
    render: () => <Tab.Pane><Documents /></Tab.Pane>
});
